import { Button, Drawer, Form, Row, Col, Tooltip, Tag } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import RadioTabs from '@/components/RadioTabs'
import Search from '@/components/SearchFilter'
import TableAntd from '@/components/TableAntd'
import useHook from './hooks'
import style from './style.module.scss'
import Buttonbar from '@/components/ButtonBar'
import moment from 'moment'

export default function materialSubmission() {
  const {
    dateSource,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    state,
    handleTableChangeCheck,
    handleExportData,
    handleProcessData,
    handleProcessPaginationChange,
    handleCloseDrawer,
    handleUpdateData,
  } = useHook()
  const {
    checkedRadioKey,
    currentRadioDict,
    isTableLoading,
    pagination,
    drawerVisible,
    processDateSource,
    isProcessTableLoading,
    processPagination,
    currentProcess,
  } = state

  const listColumn = [
    {
      key: 'operate',
      title: '操作',
      width: 150,
      render: (text: any, record: any) => {
        return (
          <div>
            <Button type="link" onClick={() => handleProcessData(record)}>
              流程记录
            </Button>
            {record.reportStatus === 'REJECTED' ? (
              <Button type="link" onClick={() => handleUpdateData(record)}>
                修改
              </Button>
            ) : (
              <Button type="link" onClick={() => handleUpdateData(record)}>
                查看详情
              </Button>
            )}
          </div>
        )
      },
    },
    {
      key: 'reportStatusName',
      title: '提报状态',
      width: 120,
    },
    {
      /**
       * 客户商品状态列 - 1.6.0 新增
       *
       * 展示物料在客户平台的审核/上下架状态
       * 状态枚举值：1-已上架 2-已下架 3-审核中 4-已驳回 5-已冻结
       *
       * 数据来源：后端在提报列表接口中透传 thirdOnShelf 字段
       *          （后端通过 POST /open/platformProduct/getThirdOnShelf 批量查询后合入）
       */
      key: 'thirdOnShelf',
      title: '客户商品状态',
      width: 130,
      titleRender: (
        <span>
          客户商品状态&nbsp;
          <Tooltip
            title="当前客户平台的审核状态，与提报状态无直接关系"
            getPopupContainer={() => document.body}
          >
            <QuestionCircleOutlined
              style={{ color: '#999', cursor: 'pointer' }}
            />
          </Tooltip>
        </span>
      ),
      render: (text: string) => {
        if (!text) return '-'
        /** 状态值 → 颜色映射 */
        const colorMap: Record<string, string> = {
          '1': 'green', // 已上架
          '2': 'red', // 已下架
          '3': 'blue', // 审核中
          '4': 'orange', // 已驳回
          '5': 'default', // 已冻结
        }
        /** 状态值 → 中文名映射 */
        const nameMap: Record<string, string> = {
          '1': '已上架',
          '2': '已下架',
          '3': '审核中',
          '4': '已驳回',
          '5': '已冻结',
        }
        return (
          <Tag color={colorMap[text] || 'default'}>{nameMap[text] || text}</Tag>
        )
      },
    },
    {
      key: 'reportTypeName',
      title: '提报类型',
    },
    {
      key: 'projectName',
      title: '项目名称',
    },
    {
      key: 'reportCode',
      title: '审批流编码',
    },
    {
      key: 'materialCode',
      title: '商品编码',
    },
    {
      key: 'materialName',
      title: '商品名称',
    },
    {
      key: 'reportTime',
      title: '提报日期',
      render: (text: any) => text && moment(text).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      key: 'auditTime',
      title: '审核时间',
      render: (text: any) => text && moment(text).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      key: 'auditUserName',
      title: '当前审核人',
    },
    {
      key: 'auditRemark',
      title: '审核备注',
    },
  ]

  const processListColumn = [
    {
      key: 'operatorName',
      title: '操作人',
    },
    {
      key: 'operationNodeName',
      title: '流程节点',
      width: 120,
    },
    {
      key: 'operationTime',
      title: '操作时间',
      render: (text: any) => text && moment(text).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      key: 'remark',
      title: '操作备注',
    },
  ]
  return (
    <div className={style['container']}>
      <Search
        fieldsData={[
          'reportStartTime',
          'reportEndTime',
          'auditStartTime',
          'auditEndTime',
          'materialCodes',
          'projectCode',
          'reportType',
          'reportCode',
        ]}
        onSearch={handleSearchClick}
        keyName="MATERIALSUBMISSION"
        ScreenKey="MATERIALSUBMISSION"
      />
      <div className={style['inner-content']}>
        <div className={style['tab-container']}>
          <RadioTabs
            defaultKey={checkedRadioKey}
            radioItemDict={currentRadioDict}
            onChange={handleCheckedChange}
          ></RadioTabs>
        </div>
        <Buttonbar onRefresh={handleTableRefresh}>
          {
            <Button type="primary" onClick={handleExportData}>
              导出数据
            </Button>
          }
        </Buttonbar>
        <TableAntd
          dataSource={dateSource}
          listColumn={listColumn}
          loading={isTableLoading}
          Y={380}
          pagination={{
            ...pagination,
            onChange: handlePaginationChange,
          }}
          showSize
          onChangeCheck={handleTableChangeCheck}
        ></TableAntd>
      </div>

      <Drawer
        title="流程记录"
        placement="right"
        onClose={handleCloseDrawer}
        open={drawerVisible}
        getContainer={false}
        mask={false}
        width={900}
      >
        <Form>
          <Row>
            <Col span={8}>
              <Form.Item label="流程编码">
                {currentProcess.reportCode}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="项目名称">
                {currentProcess.projectName}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="商品编码">
                {currentProcess.materialCode}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item label="提报状态">
                {currentProcess.reportStatusName}
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item label="审核备注">
                {currentProcess.auditRemark}
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <TableAntd
          dataSource={processDateSource}
          listColumn={processListColumn}
          loading={isProcessTableLoading}
          Y={380}
          pagination={{
            ...processPagination,
            onChange: handleProcessPaginationChange,
          }}
          showSize
        ></TableAntd>
      </Drawer>
    </div>
  )
}
import { Button, Drawer, Form, Row, Col, Tooltip, Tag } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import RadioTabs from '@/components/RadioTabs'
import Search from '@/components/SearchFilter'
import TableAntd from '@/components/TableAntd'
import useHook from './hooks'
import style from './style.module.scss'
import Buttonbar from '@/components/ButtonBar'
import moment from 'moment'

export default function materialSubmission() {
  const {
    dateSource,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    state,
    handleTableChangeCheck,
    handleExportData,
    handleProcessData,
    handleProcessPaginationChange,
    handleCloseDrawer,
    handleUpdateData,
  } = useHook()
  const {
    checkedRadioKey,
    currentRadioDict,
    isTableLoading,
    pagination,
    drawerVisible,
    processDateSource,
    isProcessTableLoading,
    processPagination,
    currentProcess,
  } = state

  const listColumn = [
    {
      key: 'operate',
      title: '操作',
      width: 150,
      render: (text: any, record: any) => {
        return (
          <div>
            <Button type="link" onClick={() => handleProcessData(record)}>
              流程记录
            </Button>
            {record.reportStatus === 'REJECTED' ? (
              <Button type="link" onClick={() => handleUpdateData(record)}>
                修改
              </Button>
            ) : (
              <Button type="link" onClick={() => handleUpdateData(record)}>
                查看详情
              </Button>
            )}
          </div>
        )
      },
    },
    {
      key: 'reportStatusName',
      title: '提报状态',
      width: 120,
    },
    {
      /**
       * 客户商品状态列 - 1.6.0 新增
       *
       * 展示物料在客户平台的审核/上下架状态
       * 状态枚举值：1-已上架 2-已下架 3-审核中 4-已驳回 5-已冻结
       *
       * 数据来源：后端在提报列表接口中透传 thirdOnShelf 字段
       *          （后端通过 POST /open/platformProduct/getThirdOnShelf 批量查询后合入）
       */
      key: 'thirdOnShelf',
      title: '客户商品状态',
      width: 130,
      titleRender: (
        <span>
          客户商品状态&nbsp;
          <Tooltip
            title="当前客户平台的审核状态，与提报状态无直接关系"
            getPopupContainer={() => document.body}
          >
            <QuestionCircleOutlined
              style={{ color: '#999', cursor: 'pointer' }}
            />
          </Tooltip>
        </span>
      ),
      render: (text: string) => {
        if (!text) return '-'
        /** 状态值 → 颜色映射 */
        const colorMap: Record<string, string> = {
          '1': 'green', // 已上架
          '2': 'red', // 已下架
          '3': 'blue', // 审核中
          '4': 'orange', // 已驳回
          '5': 'default', // 已冻结
        }
        /** 状态值 → 中文名映射 */
        const nameMap: Record<string, string> = {
          '1': '已上架',
          '2': '已下架',
          '3': '审核中',
          '4': '已驳回',
          '5': '已冻结',
        }
        return (
          <Tag color={colorMap[text] || 'default'}>{nameMap[text] || text}</Tag>
        )
      },
    },
    {
      key: 'reportTypeName',
      title: '提报类型',
    },
    {
      key: 'projectName',
      title: '项目名称',
    },
    {
      key: 'reportCode',
      title: '审批流编码',
    },
    {
      key: 'materialCode',
      title: '商品编码',
    },
    {
      key: 'materialName',
      title: '商品名称',
    },
    {
      key: 'reportTime',
      title: '提报日期',
      render: (text: any) => text && moment(text).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      key: 'auditTime',
      title: '审核时间',
      render: (text: any) => text && moment(text).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      key: 'auditUserName',
      title: '当前审核人',
    },
    {
      key: 'auditRemark',
      title: '审核备注',
    },
  ]

  const processListColumn = [
    {
      key: 'operatorName',
      title: '操作人',
    },
    {
      key: 'operationNodeName',
      title: '流程节点',
      width: 120,
    },
    {
      key: 'operationTime',
      title: '操作时间',
      render: (text: any) => text && moment(text).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      key: 'remark',
      title: '操作备注',
    },
  ]
  return (
    <div className={style['container']}>
      <Search
        fieldsData={[
          'reportStartTime',
          'reportEndTime',
          'auditStartTime',
          'auditEndTime',
          'materialCodes',
          'projectCode',
          'reportType',
          'reportCode',
        ]}
        onSearch={handleSearchClick}
        keyName="MATERIALSUBMISSION"
        ScreenKey="MATERIALSUBMISSION"
      />
      <div className={style['inner-content']}>
        <div className={style['tab-container']}>
          <RadioTabs
            defaultKey={checkedRadioKey}
            radioItemDict={currentRadioDict}
            onChange={handleCheckedChange}
          ></RadioTabs>
        </div>
        <Buttonbar onRefresh={handleTableRefresh}>
          {
            <Button type="primary" onClick={handleExportData}>
              导出数据
            </Button>
          }
        </Buttonbar>
        <TableAntd
          dataSource={dateSource}
          listColumn={listColumn}
          loading={isTableLoading}
          Y={380}
          pagination={{
            ...pagination,
            onChange: handlePaginationChange,
          }}
          showSize
          onChangeCheck={handleTableChangeCheck}
        ></TableAntd>
      </div>

      <Drawer
        title="流程记录"
        placement="right"
        onClose={handleCloseDrawer}
        open={drawerVisible}
        getContainer={false}
        mask={false}
        width={900}
      >
        <Form>
          <Row>
            <Col span={8}>
              <Form.Item label="流程编码">
                {currentProcess.reportCode}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="项目名称">
                {currentProcess.projectName}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="商品编码">
                {currentProcess.materialCode}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item label="提报状态">
                {currentProcess.reportStatusName}
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item label="审核备注">
                {currentProcess.auditRemark}
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <TableAntd
          dataSource={processDateSource}
          listColumn={processListColumn}
          loading={isProcessTableLoading}
          Y={380}
          pagination={{
            ...processPagination,
            onChange: handleProcessPaginationChange,
          }}
          showSize
        ></TableAntd>
      </Drawer>
    </div>
  )
}
